import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const PentagonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425 404.1",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 154.4l81.2 249.7h262.7L425 154.4 212.5 0z"
    })
  });
};

export { PentagonShape };
//# sourceMappingURL=PentagonShape.js.map
